import React, { useState, useEffect } from "react";
import 'font-awesome/css/font-awesome.min.css';
import { oneKlicks } from "../../../SDK/oneclick";


const Feedback = ({ data }) => {
    const [feedback, setFeedback] = useState([]);
    console.log('Feedback data :', data);

    useEffect(() => {

        fetchFeedback();
    }, []);


    const fetchFeedback = async () => {
        const tableSchema = '';
        const tableName = 'feedbacks';
        const conditions = {
            doctor_id: data.id
        };
        const orderBy = 'id DESC';
        const search = '';
        const pagination = '';
        const margedata = '';
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        console.log('Feedback response :', response);
        if (response) {
            console.log('Feedback response :', response.data);
            setFeedback(response.data);
        } else {
            setFeedback([]);
            console.log('No feedback found');
        }
    };


    return (

        <div className="tab-content dc-contentdoctab dc-haslayout www">
            <div className="dc-location-holder tab-pane fade" id="locations">

            </div>

            <div className="dc-feedback-holder tab-pane active show" id="feedback">
                <div className="dc-feedback">
                    <div className="dc-searchresult-head">
                        <div className="dc-title"><h4>Patient Feedback</h4></div>
                    </div>
                    {feedback.length > 0 ? (
                        <div className="dc-consultation-content dc-feedback-content">
                            <div className="dc-feedback-list">
                                {feedback.map((item, idx) => {
                                    // Get initials (first letter of name, fallback to '?')
                                    const name = item.name || "Anonymous";
                                    const initial = name.trim().charAt(0).toUpperCase();
                                    // Generate a color based on the index for variety
                                    const colors = [
                                        "#6C63FF", "#FF6584", "#43E97B", "#FFD166", "#3A86FF", "#FFBE0B", "#8338EC"
                                    ];
                                    const bgColor = colors[idx % colors.length];

                                    // Format date and time
                                    let dateStr = "", timeStr = "";
                                    if (item.created_at) {
                                        const dateObj = new Date(item.created_at);
                                        dateStr = dateObj.toLocaleDateString();
                                        timeStr = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                                    }

                                    // Render stars
                                    const rating = Math.round(Number(item.rating) || 0);

                                    return (
                                        <div className="dc-feedback-row" key={item.id} style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #f0f0f0', padding: '18px 0' }}>
                                            {/* Avatar with initial */}
                                            <div
                                                className="dc-feedback-avatar"
                                                style={{
                                                    width: 48,
                                                    height: 48,
                                                    borderRadius: "50%",
                                                    background: bgColor,
                                                    color: "#fff",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontWeight: "bold",
                                                    fontSize: 22,
                                                    marginRight: 18,
                                                    flexShrink: 0
                                                }}
                                                title={name}
                                            >
                                                {initial}
                                            </div>
                                            {/* Feedback content */}
                                            <div style={{ flex: 1 }}>
                                                <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                                                    <span style={{ fontWeight: 600, fontSize: 16, marginRight: 10 }}>{name}</span>
                                                    <span className="dc-feedback-stars" style={{ marginRight: 10 }}>
                                                        {[1, 2, 3, 4, 5].map(star => (
                                                            <i
                                                                key={star}
                                                                className={`fa fa-star${star <= rating ? "" : "-o"}`}
                                                                style={{
                                                                    color: star <= rating ? "#FFD700" : "#ccc",
                                                                    fontSize: 16,
                                                                    marginRight: 2
                                                                }}
                                                            />
                                                        ))}
                                                    </span>
                                                    <span style={{ color: "#888", fontSize: 13 }}>
                                                        {dateStr} {timeStr && <span style={{ marginLeft: 6 }}>{timeStr}</span>}
                                                    </span>
                                                </div>
                                                <div style={{ fontSize: 15, color: "#333" }}>
                                                    {item.comment}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <div className="dc-consultation-content dc-feedback-content">
                            <div className="dc-emptydata-holder">
                                <div className="dc-emptydata">
                                    <div className="dc-emptydetails dc-empty-articls dc-emptyholder-sm">
                                        <span></span>
                                        <em>No patient feedback yet now.</em>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>

            {/* <div className="dc-shareprofile">
                <ul className="d-flex dc-tags-social">
                    <li className="dc-sharejob">Share Profile:</li>
                    <li className="dc-fb">
                        <a href="//www.facebook.com/sharer.php?u=https%3A%2F%2Fmeddylist.com%2Fdoctors%2Fflores-emily%2F" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                    </li>
                    <li className="dc-twit">
                        <a href="//twitter.com/intent/tweet?text=Flores+Emily&amp;url=https%3A%2F%2Fmeddylist.com%2Fdoctors%2Fflores-emily%2F&amp;via=envato">
                            <i className="fab fa-twitter"></i>
                        </a>
                    </li>
                    <li className="dc-google-plus">
                        <a href="//plus.google.com/share?url=//css.meddylist.com//doctors/flores-emily/" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-google-plus-g"></i>
                        </a>
                    </li>
                    <li className="dc-instg">
                        <a href="//pinterest.com/pin/create/button/?url=//css.meddylist.com//doctors/flores-emily/&amp;media=//css.meddylist.com//wp-content/uploads/2019/09/asian-male-doctor-man-indian-wea-308x220.png&amp;description=Flores+Emily" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-pinterest-p"></i>
                        </a>
                    </li>
                </ul>
            </div> */}
        </div>

    );
};

export default Feedback;
